/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import './styles.scss'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { browserCheck } from '@ta-interaktiv/browsercheck'
import { Link } from '@ta-interaktiv/contentbricks'
import { ArticleTeasers } from '@ta-interaktiv/react-article-teasers'
import { BarChart } from 'components/barChart'

const ARTICLE_ID = '223608144488'
const isMobile = browserCheck.isMobile
const positiveGreen = '#32A691'
const negativeRed = '#F16067'
const neutralGrey = '#555555'

const chartType1 = {
  bar: {
    groupWidth: 20
  },
  backgroundColor: 'transparent',
  chartArea: {
    top: 0,
    left: isMobile ? '50%' : '30%',
    right: isMobile ? '8%' : '2%',
    bottom: '10%'
  },
  hAxis: {
    textPosition: 'none',
    gridlines: {
      color: '#ddd'
    },
    viewWindow: {
      max: 100
    }
  },
  vAxis: {
    textStyle: {
      fontSize: isMobile ? 13 : 14
    }
  },
  legend: 'none',
  enableInteractivity: false,
  annotations: {
    textStyle: {
      fontSize: isMobile ? 12 : 14
    }
  }
}

const chartType2 = {
  bar: {
    groupWidth: 20
  },
  backgroundColor: 'transparent',
  chartArea: {
    top: 0,
    left: isMobile ? '30%' : '20%',
    right: '2%',
    bottom: '10%'
  },
  hAxis: {
    textPosition: 'none',
    gridlines: {
      color: '#ddd'
    },
    viewWindow: {
      max: 100
    }
  },
  vAxis: {
    textStyle: {
      fontSize: isMobile ? 13 : 14
    }
  },
  legend: 'none',
  enableInteractivity: false,
  annotations: {
    textStyle: {
      fontSize: isMobile ? 12 : 14
    }
  }
}

export class AppComponent extends React.Component<Props, State> {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <div className='index'>
        <Masthead articleId={ARTICLE_ID} />
        <ThemeSwitch />

        <header className='ui vertical  very fitted  segment'>
          <div className='ui container'>
            <div className='ui header'>
              <h1>
                Wir haben 30 Epidemiologen gefragt, wie es mit Corona weitergeht
              </h1>
              <h2>
                Haben wir den Höhepunkt der Epidemie in der Schweiz hinter uns?
                Hat der Bundesrat richtig gehandelt? Droht uns in den nächsten
                Jahren eine neue Pandemie? 30 Experten schätzen die Lage ein.
              </h2>
            </div>
          </div>
        </header>

        <div className='ui vertical segment'>
          <div className='ui text container'>
            <div className='ta metainfo'>
              <div className='ta author'>
                Marc Brupbacher, Patrick Vögeli, Mathias Lutz
              </div>
              <div className='ta updated'>Aktualisiert am 23. Juni 2020</div>
            </div>
            <div>
              Wir haben 100 Epidemiologinnen, Virologen, Infektiologinnen und
              Biophysiker und einige andere Experten nach ihrer Einschätzung
              gefragt, wie es mit der Pandemie weitergehen könnte. Es sind
              Personen, die an den grössten Spitälern und Universitäten der
              Schweiz tätig sind und über langjährige Erfahrung auf ihrem
              Fachgebiet verfügen. Rund 30 Prozent der Angeschriebenen haben
              sich die Zeit für die Umfrage genommen. Das sind die Resultate.
            </div>
            <p className='box-beige'>
              <b>Bevor es los geht</b>
              <br />
              Die 30 Expertinnen und Experten sind keine Propheten, auch wenn
              sie von Berufs wegen jeden Tag mit der Welt von Erregern zu tun
              haben. Sie alle haben eine solch aussergewöhnliche Situation
              ebenfalls noch nie erlebt. Sie schätzen die Lage anhand ihrer
              Erfahrung und des heute verfügbaren Wissensstands ein. Die Umfrage
              erfolgte anonym.
            </p>
          </div>
          <div className='ui text container'>
            <div className='ta text'>
              <h3>Wann gibt es wirksame Medikamente gegen das Coronavirus?</h3>
              <BarChart chartData={[
                {
                  itemStyle: { color: "#202346" },
                  name: "Noch dieses Jahr (2020)",
                  value: 46.7
                },
                {
                  itemStyle: { color: "#CAC4B3" },
                  name: "Nächstes Jahr (2021)",
                  value: 33.3
                },
                {
                  itemStyle: { color: "#CAC4B3" },
                  name: "Frühstens in 2-3 Jahren",
                  value: 20
                },
                {
                  itemStyle: { color: "#CAC4B3" },
                  name: "Nie",
                  value: 0
                }
                ]} />
            </div>


            <div className='ta text'>
              <h3>Wann wird ein wirksamer Impfstoff zur Verfügung stehen?</h3>
              <BarChart chartData={[
                {
                  itemStyle: { color: "#CAC4B3" },
                  name: "Noch dieses Jahr (2020)",
                  value: 0
                },
                {
                  itemStyle: { color: "#202346" },
                  name: "Nächstes Jahr (2021)",
                  value: 90
                },
                {
                  itemStyle: { color: "#CAC4B3" },
                  name: "Frühstens in 2-3 Jahren",
                  value: 6.7
                },
                {
                  itemStyle: { color: "#CAC4B3" },
                  name: "Nie",
                  value: 3.3
                }
                ]} />
            </div>

            <div className='ta text'>
              <h3>Wann werden wir Covid-19 ausrotten?</h3>
              <BarChart chartData={[
                {
                  itemStyle: { color: "#CAC4B3" },
                  name: "Noch dieses Jahr (2020)",
                  value: 0
                },
                {
                  itemStyle: { color: "#CAC4B3" },
                  name: "Nächstes Jahr (2021)",
                  value: 0
                },
                {
                  itemStyle: { color: "#CAC4B3" },
                  name: "Frühstens in 2-3 Jahren",
                  value: 23.3
                },
                {
                  itemStyle: { color: "#202346" },
                  name: "Nie",
                  value: 76.7
                }
                ]} />
            </div>

            <ul>
              <li>
                Bei der schnellen Verfügbarkeit von spezifisch gegen Covid-19
                wirkenden Medikamenten zeigen sich die Expertinnen und Experten
                zuversichtlich. Knapp 47% glauben, dass die Entwicklung oder
                Entdeckung noch dieses Jahr gelingen könnte. Jüngst gab es mit
                dem altbekannten{' '}
                <Link
                  href='https://www.tagesanzeiger.ch/rettet-dieser-guenstige-wirkstoff-tatsaechlich-leben-473465924975'
                  allowWordWrap
                >
                  Entzündungshemmer Dexamethason
                </Link>{' '}
                erste Zeichen der Hoffnung, dass ein Medikament die Sterberate
                bei schweren Coronavirus-Verläufen senken kann.
              </li>
              <li>
                Kein einziger der 30 Befragten glaubt hingegen, dass ein
                wirksames Vakzin schon dieses Jahr bereit sein wird. Die grosse
                Mehrheit (90%) rechnet erst 2021 damit, eine Person denkt, es
                werde nie gelingen, einen wirksamen Impfstoff zu entwickeln.
                Optimistischer zeigte sich die WHO letzte Woche in Genf:
                Vorhersagen seien immer schwierig, aber wenn alles glatt laufe
                mit den derzeitigen Studien, könnten Ende Jahr schon einige
                Hundert Millionen Impfdosen hergestellt sein, sagte
                Chefwissenschaftlerin Soumya Swaminathan.
              </li>
              <li>
                Die Ausrottung einer Infektionskrankheit gelang der Menschheit
                bisher erst einmal: Die WHO erklärte nach einer erfolgreichen
                Impfkampagne die Welt 1979 für pockenfrei. Immerhin 7 der 30
                Befragten glauben daran, dass dies auch mit Covid-19 in einigen
                Jahren gelingen könnte. Die deutliche Mehrheit von rund 77% der
                Befragten sagt aber, Covid-19 sei gekommen, um zu bleiben, und
                werde endemisch.
              </li>
            </ul>
          </div>
        </div>

        <div className='ui vertical segment backdrop'>
          <div className='ui text container'>
            <div className='ta text'>
              <h3>Gibt es nach durchgemachter Krankheit eine Immunität?</h3>
              <BarChart chartData={[
                {
                  itemStyle: { color: positiveGreen },
                  name: "Ja",
                  value: 9.7
                },
                {
                  itemStyle: { color: positiveGreen },
                  name: "Eher Ja",
                  value: 67.7
                },
                {
                  itemStyle: { color: "#CAC4B3" },
                  name: "Keine Antwort",
                  value: 22.6
                },
                {
                  itemStyle: { color: "#CAC4B3" },
                  name: "Eher Nein",
                  value: 0
                },
                {
                  itemStyle: { color: "#CAC4B3" },
                  name: "Nein",
                  value: 0
                }
                ]} />
            </div>

            <div className='ta text'>
              <h3>
                Gibt es nach durchgemachter Krankheit eine Immunität, die länger
                als ein Jahr anhält?
              </h3>
              <BarChart chartData={[
                {
                  itemStyle: { color: "#CAC4B3" },
                  name: "Ja",
                  value: 0
                },
                {
                  itemStyle: { color: "#CAC4B3" },
                  name: "Eher Ja",
                  value: 40
                },
                {
                  itemStyle: { color: neutralGrey },
                  name: "Keine Antwort",
                  value: 46.6
                },
                {
                  itemStyle: { color: "#CAC4B3" },
                  name: "Eher Nein",
                  value: 13.3
                },
                {
                  itemStyle: { color: "#CAC4B3" },
                  name: "Nein",
                  value: 0
                }
                ]} />
            </div>

            <div className='ta text'>
              <h3>Wird sich durch Mutationen das Virus abschwächen?</h3>
              <BarChart chartData={[
                {
                  itemStyle: { color: "#CAC4B3" },
                  name: "Ja",
                  value: 0
                },
                {
                  itemStyle: { color: "#CAC4B3" },
                  name: "Eher Ja",
                  value: 9.7
                },
                {
                  itemStyle: { color: "#CAC4B3" },
                  name: "Keine Antwort",
                  value: 32.3
                },
                {
                  itemStyle: { color: negativeRed },
                  name: "Eher Nein",
                  value: 51.6
                },
                {
                  itemStyle: { color: negativeRed },
                  name: "Nein",
                  value: 6.5
                }
                ]} />
            </div>

            <div className='ta text'>
              <h3>Wird durch Mutationen das Virus gefährlicher?</h3>
              <BarChart chartData={[
                {
                  itemStyle: { color: "#CAC4B3" },
                  name: "Ja",
                  value: 0
                },
                {
                  itemStyle: { color: "#CAC4B3" },
                  name: "Eher Ja",
                  value: 9.7
                },
                {
                  itemStyle: { color: "#CAC4B3" },
                  name: "Keine Antwort",
                  value: 29
                },
                {
                  itemStyle: { color: negativeRed },
                  name: "Eher Nein",
                  value: 54.8
                },
                {
                  itemStyle: { color: negativeRed },
                  name: "Nein",
                  value: 6.5
                }
                ]} />
            </div>

            <div className='ta text'>
              <h3>Hat die Schweiz die richtigen Massnahmen ergriffen?</h3>
              <BarChart chartData={[
                {
                  itemStyle: { color: positiveGreen },
                  name: "Ja",
                  value: 33.3
                },
                {
                  itemStyle: { color: positiveGreen },
                  name: "Eher Ja",
                  value: 53.3
                },
                {
                  itemStyle: { color: "#CAC4B3" },
                  name: "Keine Antwort",
                  value: 13.3
                },
                {
                  itemStyle: { color: "#CAC4B3" },
                  name: "Eher Nein",
                  value: 0
                },
                {
                  itemStyle: { color: "#CAC4B3" },
                  name: "Nein",
                  value: 0
                }
                ]} />
            </div>

            <div className='ta text'>
              <h3>Hat die Schweiz zur richtigen Zeit Massnahmen ergriffen?</h3>
              <BarChart chartData={[
                {
                  itemStyle: { color: positiveGreen },
                  name: "Ja",
                  value: 11.1
                },
                {
                  itemStyle: { color: positiveGreen },
                  name: "Eher Ja",
                  value: 66.7
                },
                {
                  itemStyle: { color: "#CAC4B3" },
                  name: "Keine Antwort",
                  value: 0
                },
                {
                  itemStyle: { color: "#CAC4B3" },
                  name: "Eher Nein",
                  value: 22.2
                },
                {
                  itemStyle: { color: "#CAC4B3" },
                  name: "Nein",
                  value: 0
                }
                ]} />
            </div>

            <div className='ta text'>
              <h3>
                Aus heutiger Sicht: Hätten die Schulen offen bleiben sollen?
              </h3>
              <BarChart chartData={[
                {
                  itemStyle: { color: "#CAC4B3" },
                  name: "Ja",
                  value: 0
                },
                {
                  itemStyle: { color: "#CAC4B3" },
                  name: "Eher Ja",
                  value: 16.1
                },
                {
                  itemStyle: { color: "#CAC4B3" },
                  name: "Keine Antwort",
                  value: 12.9
                },
                {
                  itemStyle: { color: negativeRed },
                  name: "Eher Nein",
                  value: 45.2
                },
                {
                  itemStyle: { color: negativeRed },
                  name: "Nein",
                  value: 25.8
                }
                ]} />
            </div>

            <div className='ta text'>
              <h3>
                Wird es in der Schweiz eine zweite Welle geben, die grösser als
                die erste wird?
              </h3>
              <BarChart chartData={[
                {
                  itemStyle: { color: "#CAC4B3" },
                  name: "Ja",
                  value: 0
                },
                {
                  itemStyle: { color: "#CAC4B3" },
                  name: "Eher Ja",
                  value: 6.7
                },
                {
                  itemStyle: { color: "#CAC4B3" },
                  name: "Keine Antwort",
                  value: 30
                },
                {
                  itemStyle: { color: negativeRed },
                  name: "Eher Nein",
                  value: 60
                },
                {
                  itemStyle: { color: negativeRed },
                  name: "Nein",
                  value: 3.3
                }
                ]} />
            </div>

            <div className='ta text'>
              <h3>
                Wird es in der Schweiz eine zweite Welle geben, die kleiner als
                die erste wird?
              </h3>
              <BarChart chartData={[
                {
                  itemStyle: { color: positiveGreen },
                  name: "Ja",
                  value: 9.7
                },
                {
                  itemStyle: { color: positiveGreen },
                  name: "Eher Ja",
                  value: 61.3
                },
                {
                  itemStyle: { color: "#CAC4B3" },
                  name: "Keine Antwort",
                  value: 19.4
                },
                {
                  itemStyle: { color: "#CAC4B3" },
                  name: "Eher Nein",
                  value: 9.7
                },
                {
                  itemStyle: { color: "#CAC4B3" },
                  name: "Nein",
                  value: 0
                }
                ]} />
            </div>

            <div className='ta text'>
              <h3>
                Haben wir in der Schweiz die schlimmste Phase der Epidemie
                überstanden?
              </h3>
              <BarChart chartData={[
                {
                  itemStyle: { color: positiveGreen },
                  name: "Ja",
                  value: 9.7
                },
                {
                  itemStyle: { color: positiveGreen },
                  name: "Eher Ja",
                  value: 64.5
                },
                {
                  itemStyle: { color: "#CAC4B3" },
                  name: "Keine Antwort",
                  value: 19.4
                },
                {
                  itemStyle: { color: "#CAC4B3" },
                  name: "Eher Nein",
                  value: 6.5
                },
                {
                  itemStyle: { color: "#CAC4B3" },
                  name: "Nein",
                  value: 0
                }
                ]} />
            </div>

            <div className='ta text'>
              <h3>
                Waren Sie überrascht, wie stark die Fallzahlen in der Schweiz
                mit den Massnahmen sanken?
              </h3>
              <BarChart chartData={[
                {
                  itemStyle: { color: "#CAC4B3" },
                  name: "Ja",
                  value: 9.7
                },
                {
                  itemStyle: { color: "#CAC4B3" },
                  name: "Eher Ja",
                  value: 29
                },
                {
                  itemStyle: { color: "#CAC4B3" },
                  name: "Keine Antwort",
                  value: 3.2
                },
                {
                  itemStyle: { color: negativeRed },
                  name: "Eher Nein",
                  value: 29
                },
                {
                  itemStyle: { color: negativeRed },
                  name: "Nein",
                  value: 29
                }
                ]} />
            </div>

            <div className='ta text'>
              <h3>
                Waren Sie überrascht über das eingetroffene Szenario, dass sich
                mit Sars-Cov-2 ein eher ansteckendes und eher gefährliches Virus
                auf der Welt so schnell ausbreitet?
              </h3>
              <BarChart chartData={[
                {
                  itemStyle: { color: "#CAC4B3" },
                  name: "Ja",
                  value: 6.5
                },
                {
                  itemStyle: { color: "#CAC4B3" },
                  name: "Eher Ja",
                  value: 22.6
                },
                {
                  itemStyle: { color: "#CAC4B3" },
                  name: "Keine Antwort",
                  value: 6.5
                },
                {
                  itemStyle: { color: negativeRed },
                  name: "Eher Nein",
                  value: 19.4
                },
                {
                  itemStyle: { color: negativeRed },
                  name: "Nein",
                  value: 45.2
                }
                ]} />
            </div>

            <div className='ta text'>
              <h3>
                Wird sich in den nächsten 10 Jahren eine Pandemie ähnlichen
                Ausmasses ereignen?
              </h3>
              <BarChart chartData={[
                {
                  itemStyle: { color: positiveGreen },
                  name: "Ja",
                  value: 3.2
                },
                {
                  itemStyle: { color: positiveGreen },
                  name: "Eher Ja",
                  value: 51.6
                },
                {
                  itemStyle: { color: "#CAC4B3" },
                  name: "Keine Antwort",
                  value: 22.6
                },
                {
                  itemStyle: { color: "#CAC4B3" },
                  name: "Eher Nein",
                  value: 22.6
                },
                {
                  itemStyle: { color: "#CAC4B3" },
                  name: "Nein",
                  value: 0
                }
                ]} />
            </div>

            <div className='ta text'>
              <h3>
                Werden wir auf die nächste Pandemie besser vorbereitet sein?
              </h3>
              <BarChart chartData={[
                {
                  itemStyle: { color: positiveGreen },
                  name: "Ja",
                  value: 13.8
                },
                {
                  itemStyle: { color: positiveGreen },
                  name: "Eher Ja",
                  value: 69
                },
                {
                  itemStyle: { color: "#CAC4B3" },
                  name: "Keine Antwort",
                  value: 10.3
                },
                {
                  itemStyle: { color: "#CAC4B3" },
                  name: "Eher Nein",
                  value: 6.9
                },
                {
                  itemStyle: { color: "#CAC4B3" },
                  name: "Nein",
                  value: 0
                }
                ]} />
            </div>

            <div className='ta text'>
              <h3>Ist das Virus einem Labor entwichen?</h3>
              <BarChart chartData={[
                {
                  itemStyle: { color: "#CAC4B3" },
                  name: "Ja",
                  value: 0
                },
                {
                  itemStyle: { color: "#CAC4B3" },
                  name: "Eher Ja",
                  value: 0
                },
                {
                  itemStyle: { color: "#CAC4B3" },
                  name: "Keine Antwort",
                  value: 9.7
                },
                {
                  itemStyle: { color: negativeRed },
                  name: "Eher Nein",
                  value: 25.8
                },
                {
                  itemStyle: { color: negativeRed },
                  name: "Nein",
                  value: 64.5
                }
                ]} />
            </div>

            <div className='ta text'>
              <h3>
                Ist das Virus natürlichen Ursprungs und von Tier auf den
                Menschen gesprungen?
              </h3>
              <BarChart chartData={[
                {
                  itemStyle: { color: positiveGreen },
                  name: "Ja",
                  value: 54.8
                },
                {
                  itemStyle: { color: positiveGreen },
                  name: "Eher Ja",
                  value: 38.7
                },
                {
                  itemStyle: { color: "#CAC4B3" },
                  name: "Keine Antwort",
                  value: 6.45
                },
                {
                  itemStyle: { color: "#CAC4B3" },
                  name: "Eher Nein",
                  value: 0
                },
                {
                  itemStyle: { color: "#CAC4B3" },
                  name: "Nein",
                  value: 0
                }
                ]} />
            </div>

            <div className='ta text'>
              <h3>Fürchten Sie sich vor einer Infektion mit SARS-CoV-2?</h3>
              <BarChart chartData={[
                {
                  itemStyle: { color: "#CAC4B3" },
                  name: "Ja",
                  value: 3.2
                },
                {
                  itemStyle: { color: "#CAC4B3" },
                  name: "Eher Ja",
                  value: 32.3
                },
                {
                  itemStyle: { color: "#CAC4B3" },
                  name: "Keine Antwort",
                  value: 12.9
                },
                {
                  itemStyle: { color: negativeRed },
                  name: "Eher Nein",
                  value: 45.2
                },
                {
                  itemStyle: { color: negativeRed },
                  name: "Nein",
                  value: 6.5
                }
                ]} />
            </div>

            <ul>
              <li>
                Eine der wichtigsten Fragen lautet: Gibt es überhaupt eine
                Immunität nach durchgemachter Krankheit? Denn wenn nicht, könnte
                uns auch kein Impfstoff retten. Die Umfrageteilnehmer sind
                optimistisch: 77% denken, es baue sich eine Immunität auf, und
                40% glauben, sie halte auch länger als ein Jahr an. Wobei 47%
                der Befragten bei der Dauer des Schutzes keine Prognose wagen.
                Niemand ist der Meinung, dass es gar keinen Immunitätsschutz
                gibt.
              </li>
              <li>
                Die Sars-CoV-2-Viren können sich wie alle Viren mit der Zeit
                verändern. Bislang sind aber noch{' '}
                <Link href='https://www.tagesanzeiger.ch/wie-gefaehrlich-ist-der-in-peking-aufgetauchte-typ-832510145265'>
                  keine Mutationen
                </Link>{' '}
                bekannt, die das Virus nachweislich aggressiver oder
                ansteckender gemacht haben. Mit rund 60% glaubt auch eine
                Mehrheit der Befragten, dass das Virus weder schwächer noch
                gefährlicher werden wird. Rund 30% wollten sich aber bei beiden
                Fragen nicht auf die Äste hinauslassen und gaben keine Antwort.
                Nur eine kleine Minderheit von 10% denkt, dass das Virus so
                stark mutieren wird, dass es seine Eigenschaften ändert.
              </li>
              <li>
                Über 85% sind der Meinung, die Schweiz habe die richtigen
                Massnahmen gegen Sars-Cov-2 ergriffen. Keine einzige Person fand
                die Strategie des Bundes grundsätzlich falsch. Nur beim Timing
                gibt es minimale Kritik, 22% finden, der Bundesrat habe zu lange
                gezögert, knapp 78% denken, die Beschlüsse kamen zur richtigen
                Zeit. Dieses Ergebnis kommt in der Eindeutigkeit überraschend,
                so gab es doch von{' '}
                <Link href='https://www.tagesanzeiger.ch/corona-streit-geht-in-die-zweite-runde-529698570331'>
                  wissenschaftlicher Seite
                </Link>{' '}
                auch immer wieder Kritik am offiziellen Vorgehen, und{' '}
                <Link href='https://www.tagesanzeiger.ch/diese-dokumente-zeigen-wie-der-bund-die-pandemie-unterschaetzt-hat-759682212111'>
                  Protokolle
                </Link>{' '}
                zeigten auch, dass der Bund die Pandemie unterschätzt und
                wichtige Zeit im Kampf gegen das Coronavirus verloren hat.
              </li>
              <li>
                Hätte man die Schulen gar nie schliessen müssen? Obwohl es
                mittlerweile viele Studien gibt, die darauf hindeuten, dass die
                ganz Jungen tatsächlich nicht die Treiber der Corona-Epidemie
                sind, findet dennoch eine Mehrheit von 70%, dass es richtig war,
                den Schulbetrieb zu unterbrechen. Vorsicht ist besser als
                Nachsicht.
              </li>
              <li>
                Bei den nächsten drei Fragen zeigen sich die Expertinnen und
                Experten optimistisch. Eine deutliche Mehrheit von 74% ist der
                Meinung, die Schweiz habe die schlimmste Phase der Pandemie
                überstanden, und die zweite Welle, die zweifelsohne kommen werde
                (71%), dürfte kleiner ausfallen als die erste.
              </li>
              <li>
                Bei den Zukunftsaussichten kippt der Optimismus in Pessimismus:
                55% schätzen, dass sich eine Pandemie ähnlichen Ausmasses in den
                nächsten 10 Jahren wiederholen wird. Knapp 83% sind der Meinung,
                dass wir dann aber besser vorbereitet sein werden.
              </li>
              <li>
                Die Expertinnen und Experten lassen sich nicht einschüchtern:
                Über 51% fürchten sich eher nicht vor einer Infektion, 33% ein
                bisschen.
              </li>
            </ul>
          </div>
        </div>

        <div className='ui vertical segment'>
          <div className='ui text container compact-answers'>
            <div className='ta text' style={{ paddingBottom: '2em' }}>
              <h3>Wann werden Sie folgende Dinge wieder tun?</h3>
              <table className='ui sigle line small compact unstackable table'>
                <thead>
                  <tr>
                    <th />
                    <th>
                      Jetzt
                      <br />
                      schon
                    </th>
                    <th>
                      In 3–12
                      <br />
                      Monaten
                    </th>
                    <th>
                      Frühstens
                      <br />
                      in 1 Jahr
                    </th>
                    <th>
                      Nie
                      <br />
                      mehr
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <div className='content'>Eine Wanderung mit Freunden</div>
                    </td>
                    <td className='top-value'>96,7%</td>
                    <td>3,3%</td>
                    <td>0%</td>
                    <td>0%</td>
                  </tr>

                  <tr>
                    <td>
                      <div className='content'>
                        Pakete ohne Vorsichtsmassnahmen entgegennehmen
                      </div>
                    </td>
                    <td className='top-value'>87,1%</td>
                    <td>9,7%</td>
                    <td>3,2%</td>
                    <td>0%</td>
                  </tr>

                  <tr>
                    <td>
                      <div className='content'>Kurzferien in der Schweiz</div>
                    </td>
                    <td className='top-value'>86,7%</td>
                    <td>13,3%</td>
                    <td>0%</td>
                    <td>0%</td>
                  </tr>

                  <tr>
                    <td>
                      <div className='content'>
                        Abendessen bei Freunden oder Familie
                      </div>
                    </td>
                    <td className='top-value'>83,9%</td>
                    <td>16,1%</td>
                    <td>0%</td>
                    <td>0%</td>
                  </tr>

                  <tr>
                    <td>
                      <div className='content'>
                        Die öffentlichen Verkehrsmittel benutzen
                      </div>
                    </td>
                    <td className='top-value'>80,6%</td>
                    <td>16,3%</td>
                    <td>3,23%</td>
                    <td>0%</td>
                  </tr>

                  <tr>
                    <td>
                      <div className='content'>
                        Artzbesuch in nicht dringenden Fällen
                      </div>
                    </td>
                    <td className='top-value'>77,4%</td>
                    <td>12,9%</td>
                    <td>6,5%</td>
                    <td>3,2%</td>
                  </tr>

                  <tr>
                    <td>
                      <div className='content'>Restaurantbesuche</div>
                    </td>
                    <td className='top-value'>77,4%</td>
                    <td>19,4%</td>
                    <td>3,2%</td>
                    <td>0%</td>
                  </tr>

                  <tr>
                    <td>
                      <div className='content'>Zum Coiffeur gehen</div>
                    </td>
                    <td className='top-value'>76,7%</td>
                    <td>20%</td>
                    <td>0%</td>
                    <td>3,3%</td>
                  </tr>

                  <tr>
                    <td>
                      <div className='content'>Ältere Menschen besuchen</div>
                    </td>
                    <td className='top-value'>60%</td>
                    <td>23,3%</td>
                    <td>16,7%</td>
                    <td>0%</td>
                  </tr>

                  <tr>
                    <td>
                      <div className='content'>Im Grossraumbüro arbeiten</div>
                    </td>
                    <td className='top-value'>43,3%</td>
                    <td>36,7%</td>
                    <td>13,3%</td>
                    <td>6,7%</td>
                  </tr>

                  <tr>
                    <td>
                      <div className='content'>
                        Ins Kino, Oper, Theater gehen
                      </div>
                    </td>
                    <td>12,9%</td>
                    <td className='top-value'>71%</td>
                    <td>16,1%</td>
                    <td>0%</td>
                  </tr>

                  <tr>
                    <td>
                      <div className='content'>Ferien im Ausland</div>
                    </td>
                    <td>32,2%</td>
                    <td className='top-value'>58,1%</td>
                    <td>9,7%</td>
                    <td>0%</td>
                  </tr>

                  <tr>
                    <td>
                      <div className='content'>
                        Teilnahme an Hochzeit, Beerdigung oder Familienfest
                      </div>
                    </td>
                    <td>43,3%</td>
                    <td className='top-value'>56,7%</td>
                    <td>0%</td>
                    <td>0%</td>
                  </tr>

                  <tr>
                    <td>
                      <div className='content'>Mit dem Flugzeug reisen</div>
                    </td>
                    <td>16,1%</td>
                    <td className='top-value'>54,8%</td>
                    <td>29%</td>
                    <td>0%</td>
                  </tr>

                  <tr>
                    <td>
                      <div className='content'>
                        Training im Fitnessstudio, Tanzkurse, Sportkurse
                      </div>
                    </td>
                    <td>12,9%</td>
                    <td className='top-value'>54,8%</td>
                    <td>22,6%</td>
                    <td>9,7%</td>
                  </tr>

                  <tr>
                    <td>
                      <div className='content'>
                        An Grossanlässen teilnehmen (Open Air, Konzerte, Sport)
                      </div>
                    </td>
                    <td>0%</td>
                    <td>22,6%</td>
                    <td className='top-value'>74,2%</td>
                    <td>3,2%</td>
                  </tr>

                  <tr>
                    <td>
                      <div className='content'>
                        Verzicht auf die Distanzregeln im Alltag
                      </div>
                    </td>
                    <td>0%</td>
                    <td>26,7%</td>
                    <td className='top-value'>63,3%</td>
                    <td>10%</td>
                  </tr>

                  <tr>
                    <td>
                      <div className='content'>
                        Freunden zur Begrüssung die Hand schütteln
                      </div>
                    </td>
                    <td>3,5%</td>
                    <td>20,7%</td>
                    <td className='top-value'>55,2%</td>
                    <td>20,7%</td>
                  </tr>

                  <tr>
                    <td>
                      <div className='content'>
                        Freunde zur Begrüssung umarmen
                      </div>
                    </td>
                    <td>3,5%</td>
                    <td>31%</td>
                    <td className='top-value'>51,7%</td>
                    <td>13,8%</td>
                  </tr>

                  <tr>
                    <td>
                      <div className='content'>
                        Freunde zur Begrüssung küssen
                      </div>
                    </td>
                    <td>0%</td>
                    <td>23,3%</td>
                    <td className='top-value'>50%</td>
                    <td>26,7%</td>
                  </tr>
                </tbody>
                {isMobile && (
                  <tfoot>
                    <tr>
                      <th />
                      <th>
                        Jetzt
                        <br />
                        schon
                      </th>
                      <th>
                        In 3–12
                        <br />
                        Monaten
                      </th>
                      <th>
                        Frühstens
                        <br />
                        in 1 Jahr
                      </th>
                      <th>
                        Nie
                        <br />
                        mehr
                      </th>
                    </tr>
                  </tfoot>
                )}
              </table>
            </div>

            <ul>
              <li>
                Viele der abgefragten Tätigkeiten und Handlungen werden von den
                meisten Expertinnen und Experten bereits heute wieder ausgeübt:
                Wanderungen mit Freunden, Arztbesuche, Kurzferien in der
                Schweiz, ÖV nutzen, Restaurantbesuche, zum Coiffeur gehen,
                Abendessen bei Freunden.
              </li>
              <li>
                Skeptisch zeigen sie sich noch bei Flugzeugreisen ins Ausland,
                dem Besuch von Theater, Oper, Kino und Fitnessstudio und der
                Teilnahme an Familienanlässen oder auch der Arbeit im
                Grossraumbüro. Da wollen sich die meisten noch einige Monate
                gedulden.
              </li>
              <li>
                Freunde zur Begrüssung die Hand schütteln, küssen oder umarmen
                will die Mehrheit erst nächstes Jahr wieder. Rund ein Fünftel
                der Befragten will sogar in Zukunft auf diese Begrüssungsrituale
                ganz verzichten. Auch Grossanlässe wie Konzerte und
                Sportveranstaltungen will die Mehrheit erst in einem Jahr wieder
                besuchen. Und auch die Distanzregeln wollen sie noch mindestens
                ein Jahr beibehalten.
              </li>
            </ul>
          </div>
          <div className='ui text container summary'>
            <h2>
              Wie die Mehrheit der 30 Expertinnen und Experten die Lage
              einschätzt
            </h2>
            <p>
              Die Schweiz hat die schlimmste Phase der Epidemie überstanden. Es
              wird zwar zu einer zweiten Welle kommen, die wird aber kleiner
              ausfallen als die erste. Das Virus wird sich durch Mutationen
              nicht gross verändern, also weder gefährlicher noch milder werden.
              Mit wirksamen Medikamenten ist schon dieses Jahr zu rechnen, mit
              einem Impfstoff erst 2021. Covid-19 ist gekommen, um zu bleiben,
              Sars-CoV-2 wird wie die Grippe endemisch werden. Wer einmal an
              Covid-19 erkrankt ist, darf mit einer Immunität rechnen, zumindest
              für eine gewisse Zeit. Der Bundesrat hat die richtigen Massnahmen
              zur richtigen Zeit ergriffen; es war damals auch richtig, die
              Schulen zu schliessen. Das neue Coronavirus ist nicht aus einem
              Labor entwichen, sondern ganz natürlich vom Tier auf den Menschen
              übergesprungen. In den nächsten 10 Jahren wird sich eine Pandemie
              ähnlichen Ausmasses ereignen, auf die wir aber besser vorbereitet
              sein werden.
            </p>
          </div>
        </div>
        <Footer
          articleId={ARTICLE_ID}
          questions={[
            'Wie informativ war der Beitrag?',
            'Wie gefällt Ihnen die Gestaltung?',
            'Teilen Sie die Einschätzung der Experten?'
          ]}
          credits={[
            [
              'Konzept und Umsetzung',
              'Marc Brupbacher, Patrick Vögeli, Mathias Lutz'
            ],
            [
              'Inspiration',
              'When 511 Epidemiologists Expect to…, «<a href="https://www.nytimes.com/interactive/2020/06/08/upshot/when-epidemiologists-will-do-everyday-things-coronavirus.html">The New York Times</a>», Juni 2020'
            ]
          ]}
        >
          <div
            className='ui container'
            style={{ margin: isMobile ? '1.2em 0 3em' : '0 0 3em' }}
          >
            <h4 className='teaser'>Weitere Beiträge zum Thema</h4>
            <ArticleTeasers
              numberOfCards='three'
              articleIds={[
                '921118466582',
                '367341950277',
                '448154497109',
                '18727947',
                '835706479183',
                '147144460867',
                '100288781781',
                '533675517866'
              ]}
            />
          </div>
        </Footer>
      </div>
    )
  }
}
